module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo6-6de56336143fec4fd64b345f9aefbe66.jpg";